module.exports = __webpack_public_path__ + "img/1728609413590-Screenshot_11-10-2024_91640_www.instagram.com.jpeg.c7839a21.webp";